// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3xzFu","amount":"Amount_amount__1v_m6","tip":"Amount_tip__3p207","tipHeader":"Amount_tipHeader__3bqQ3","tipsWrap":"Amount_tipsWrap__1gY6i"};